import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import './LoadingOverlay.css';
const LoadingOverlay = () => {
    return(
        <div className="tsg-loading-overlay">
            <h1>Generating PDF</h1>
            <LoadingSpinner />
        </div>
    );
}

export default LoadingOverlay;